import { default as BaseServices } from "lib/BaseServices";

class HEXServices {

    getReport(org, impl, report, data){
        return BaseServices.rawPost(["export", org, impl, report], data);
    }

    getHexDownload(org, id, filename){
        const url = BaseServices.url(["export", org, "history", id, filename]);
        window.open(url, "_blank");
    }

    loadHexHistory(org){
        return BaseServices.getRequest(["export", org, "history"]);
    }

    loadHexParticipants(org, impl, report){
        return this.loadData(org, impl, report, "participants");
    }

    loadHexDateRange(org, impl, report, data){
        return this.loadData(org, impl, report, "date-range", data);
    }

    loadHexOptionalFields(org, impl, report){
        return this.loadData(org, impl, report, "optional-fields");
    }

    loadData(org, impl, report, endpoint, params) {
        return BaseServices.getRequest(["export", org, impl, report, endpoint], params);
    }
    
}

export default new HEXServices();



// WEBPACK FOOTER //
// ./app/lib/HEXServices.js